// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 39 ? "89b8561a" : chunkId) + "." + {"39":"015d51115523bcb7","345":"a0b431f463cffdcc"}[chunkId] + ".js";
};